import { safeMapToEntity } from "@/data/repo-Implement/safe-map-to-entity";
import { SelfSignupTokenMapper } from "@/data/mapper/self-signup-token-mapper";
import { resetPasswordByLinkRequestPayload } from "@/data/payload/auth/change-password-by-link-request-payload";
import { InitPasswordByLinkRequestPayload } from "@/data/payload/auth/init-password-by-lint-request-payload";
import { SendFindPasswordLinkByEmailPayload } from "@/data/payload/auth/send-find-password-link-by-email-payload";
import { ValidUserCodeRequestPayload } from "@/data/payload/auth/valid-user-auth-token-request-payload";
import { UserPasswordManageSource } from "@/data/source/user-password-reset-source";
import { UserAuthCodeTokenEntity } from "@/domain/entity/phone-auth-token-entity";
import { SelfSignupTokenEntity } from "@/domain/entity/self-signup-token-entity";
import { UserPasswordManageRepository } from "@/domain/repository/user-password-reset-repository";
import { SATError, SATResult } from "@sadtx/sat-error";
import { IssueUserCodeRequestPayload } from "../payload/auth/issue-user-code-request-payload";

export class UserPasswordManageRepositoryImpl implements UserPasswordManageRepository {
  //MARK:- Constructor
  constructor(private readonly userPasswordManageSource: UserPasswordManageSource) {}

  async issueUserAuthCode(
    payload: IssueUserCodeRequestPayload
  ): Promise<SATResult<UserAuthCodeTokenEntity, SATError>> {
    const result = await this.userPasswordManageSource.issueUserAuthCode(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(result.value!);
  }

  //MARK:- sendEmailAuthCode
  async sendEmailIncludePasswordResetLink(
    payload: SendFindPasswordLinkByEmailPayload
  ): Promise<SATResult<void, SATError>> {
    const result = await this.userPasswordManageSource.sendEmailAuthCode(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  //MARK:- validUserAuthCode
  async validUserAuthCode(
    payload: ValidUserCodeRequestPayload
  ): Promise<SATResult<SelfSignupTokenEntity, SATError>> {
    const result = await this.userPasswordManageSource.validUserAuthCode(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return safeMapToEntity(
      result.value,
      SelfSignupTokenMapper.toEntity,
      "UserPasswordManageRepositoryImpl::validUserAuthCode"
    );
  }

  //MARK:- resetPasswordByLink
  async resetPasswordByLink(
    payload: resetPasswordByLinkRequestPayload
  ): Promise<SATResult<void, SATError>> {
    const result = await this.userPasswordManageSource.resetPasswordByLink(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  //MARK:- initPassword
  async setInitialPasswordByLink(
    payload: InitPasswordByLinkRequestPayload
  ): Promise<SATResult<void, SATError>> {
    const result = await this.userPasswordManageSource.setInitialPasswordByLink(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
